import * as React from 'react';
import { BaseBlockView } from '../base-block.view';
import { EmailTextBlockModel } from '../../../model/block';
import { inject, observer } from 'mobx-react';
import { IInjectedProps } from '../../../interface/component/injected-props.interface';
import { EmailDraftToHtml } from '../../email-draft-to-html/email-draft-to-html';
import { isDraftEmpty } from '../../../util/draft/is-draft-empty.util';
import { findLinkedDataById } from '../../../util/page/find-linked-data-by-id.util';
import { SMALL_SCREEN_SIZE } from '../../../constants';

const style: React.CSSProperties = {
  padding: '20px 40px',
  boxSizing: 'border-box',
  wordWrap: 'break-word',
  margin: '0 auto',
  width: SMALL_SCREEN_SIZE
};

@inject('state')
@observer
export class EmailTextBlockView extends BaseBlockView<EmailTextBlockModel, IInjectedProps> {
  render() {
    const mentions = this.props.content.getUsedMentions(this.props.state.activeDesign.data);
    const hasContent = mentions.length === 0 ? !isDraftEmpty(this.props.content.text) : mentions.some((mention) => {
      const linkedData = findLinkedDataById(mention, this.props.state.activeDesign.data);
      return linkedData && linkedData.data !== null && linkedData.data !== undefined;
    });
    if (!hasContent && !this.props.inEditor) {
      return null;
    }
    let finalStyle = style;
    if (this.props.content.textBackgroundColor && this.props.content.textBackgroundColor !== 'Transparent') {
      finalStyle = Object.assign({}, finalStyle, {backgroundColor: this.props.state.colors.getColor(this.props.content.textBackgroundColor)});
    }
    return (
      <td style={finalStyle}>
        <EmailDraftToHtml
          draft={this.props.content.text}
          inEditor={this.props.inEditor}
        />
      </td>
    );
  }
}
